

<template>
  <div class="searchpage">
    <header class="search_header">
      <div class="search_bar">
        <i
          class="material-icons"
          v-if="searchTerm.length==0"
          @click="goToSearchResult(searchTerm)"
        >search</i>
        <i
          v-if="searchTerm.length>0"
          class="material-icons srch_icon"
          @click="clearSearchText()"
        >clear</i>
        <input
          class="cstm_srchbar"
          type="text"
          id="myInput"
          v-on:keyup="searchProducts($event)"
          autofocus
          :placeholder="$t('searchItem')"
          v-model="searchTerm"
        />
      </div>
      <span class="cancel_button" @click="goBack()">Cancel</span>
    </header>
    <section class="detail_content">
      <div class="search_key_section hide" :class="{'show': suggestions.length>0 && visible}">
        <h3 v-if="searchTerm.length==0">Hot Keywords</h3>
        <ul class="search_menu">
          <li
            v-bind:class="{'last': suggestions.length==1}"
            v-for="(p,index) in suggestions"
            :key="index"
            @click="goToSearchResult(p)"
          >
            <span>{{suggestions[index]}}</span>
            <span class="serachHit">
              <i class="material-icons">call_made</i>
            </span>
          </li>
        </ul>
      </div>
      <div
        class="padd15"
        v-if="salesProducts!=null && salesProducts.length>0"
        style="padding-top:15px"
      >
        <div class="filter_product_list flx">
          <div
            class="filter_card fadeInUp"
            v-for="(product,index) in salesProducts"
            :key="index"
            @click="goToProductDetail(product.saleReferenceID)"
          >
            <div class="img_wrapper spinner_wrapper" v-lazyload v-if="product.displayImage">
              <ImageSpinner class="image_spinner" />
              <img :data-url="product.displayImage" alt />
            </div>
            <div class="product_detail">
              <div class="my_price_section">
                <span class="my_price">₹​ {{product.groupPrice}}</span>
                <span class="selling_price">₹​ {{product.markedPrice}}</span>
              </div>
              <span class="bought">
                <strong>{{product.peopleBought}}</strong>
                {{$t('peopleHaveBrought')}}
              </span>
            </div>
          </div>
        </div>
        <infinite-loading @infinite="getSearchProducts" spinner="circles">
          <template slot="no-results">रिकॉर्ड उपलब्ध नहीं है</template>
        </infinite-loading>
      </div>

      <div class="notfoundProduct" v-if="notfounrdPrdt">इस श्रेणी के लिए कोई उत्पाद नहीं मिला</div>
    </section>
    <div class="cntntLoad" v-if="loading">
      <img src="../assets/images/loader.gif" alt="loader" />
    </div>
  </div>
</template>

<script>
import "../assets/css/product-list.scss";
import constant from "../utils/constant";
import ImageSpinner from "../components/Common/ImageSpinner";
import VueCookie from "vue-cookie";
import { bus } from "../main";
import InfiniteLoading from "vue-infinite-loading";
import Vue from "vue";
Vue.use(InfiniteLoading);

export default {
  name: "SearchPage",
  components: {
    ImageSpinner,
    InfiniteLoading
  },
  data() {
    return {
      msg: "Welcome to Your Vue.js PWA",
      salesProducts: [],
      pageIndex: 0,
      loading: false,
      notfounrdPrdt: false,
      comments: [],
      comment: "",
      searchTerm: "",
      suggestions: [],
      cmnt_limit: 6,
      lastCommentTimestamp: 0
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    goToProductDetail(productSrId) {
      this.$router.onError(err => {
        if (/loading chunk \d* failed./i.test(err.message)) {
           window.location.reload()
        }
      });
      this.$router.push("/detail/" + productSrId + "?source=SEARCHING");
    },
    getUserPrice(saleReferenceID, productDto) {
      this.loading = true;
      this.$store
        .dispatch({
          type: "getUserPriceProduct",
          payload: saleReferenceID
        })
        .then(
          data => {
            productDto.sellingPrice = data.data.totalPaidAmount;
            this.loading = false;
          },
          response => {
            this.loading = false;
            productDto.sellingPrice = productDto.groupPrice;
          }
        );
    },

    goToSearchResult(prodName) {
      var p = prodName;
      this.searchTerm = p;
      if (p && p.length > 0) {
        this.suggestions = [];
        this.pageIndex = 0;
        this.loading = false;
        this.getSearchProducts();
      }
    },

    clearSearchText() {
      this.searchTerm = "";
      this.salesProducts = [];
      this.searchProducts("");
    },

    searchProducts(event) {
      var term = null;
      if (event != "" && event.target.value) {
        term = event.target.value;
        this.salesProducts = [];
      }

      if (
        event != null &&
        typeof event.keyCode != "undefined" &&
        event.keyCode == 13
      ) {
        this.searchTerm = term;
        if (term == null && this.suggestions.length > 0) {
          this.searchTerm = this.suggestions[0];
        }
        if (this.searchTerm && this.searchTerm.length > 0) {
          this.suggestions = [];
          this.pageIndex = 0;
          this.loading = false;
          this.getSearchProducts();
        }
      } else {
        this.$store
          .dispatch({
            type: "getSuggestionList",
            payload: term
          })
          .then(data => {
            this.suggestions = data.data.suggestions;
            if (this.suggestions.length == 0) {
              this.notfounrdPrdt = !this.notfounrdPrdt;
            }
            this.notfounrdPrdt = false;
            this.visible = true;
          })
          .catch(err => {
            let obj = {
              status: "Failure",
              timeoutMs: "5000"
            };
            bus.$emit("apiStatus", obj);
          });
      }
    },

    getSearchProducts($state) {
      if (this.searchTerm && this.searchTerm.length > 0) {
        if (this.pageIndex != -1) {
          if (!$state) {
            this.loading = true;
          }
          this.$store
            .dispatch({
              type: "getSearchedProduct",
              payload: this.searchTerm.replace(
                /[&\/\\#,^+()$~%.'":*?<>{}]/g,
                ""
              ),
              index: this.pageIndex
            })
            .then(data => {
              $state && $state.loaded();
              if (data.data.saleProductDTOs.length > 0) {
                this.pageIndex = this.pageIndex + 1;
                this.salesProducts = this.salesProducts.concat(
                  data.data.saleProductDTOs
                );

                this.$store.commit("saveData", {
                  salesProducts: this.searchProducts,
                  pageIndex: this.pageIndex,
                  type: "search"
                });
                this.loading = false;
              } else {
                this.pageIndex = -1;
                this.loading = false;
                if (this.salesProducts == 0) {
                  this.notfounrdPrdt = true;
                }
                $state && $state.complete();
              }
            })
            .catch(err => {
              this.loading = false;
              let obj = {
                status: "Failure",
                timeoutMs: "5000"
              };
              bus.$emit("apiStatus", obj);
            });
        }
      }
    }
  },
  mounted() {
    this.searchProducts("");
  }
};
</script>
